import { render, staticRenderFns } from "./negativeList.vue?vue&type=template&id=2b7d9d82&scoped=true"
import script from "./negativeList.vue?vue&type=script&lang=js"
export * from "./negativeList.vue?vue&type=script&lang=js"
import style0 from "./negativeList.vue?vue&type=style&index=0&id=2b7d9d82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d9d82",
  null
  
)

export default component.exports